import React, { memo } from 'react';
import { TaxImpactHeader } from './tax-impact-header';
import { Block } from '../../components/core';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { TaxImpactContent } from './tax-impact-content';
import { TaxImpactErrorWrapper } from '../../../studio-blocks/components/error-wrappers/TaxImpactErrorWrapper';

export const TaxImpactBlock = memo(function InternalTaxImpactBlock({ id }: { id: string }) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <TaxImpactHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, MetricsErrorWrapper, TaxImpactErrorWrapper]}>
        <TaxImpactContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
